import { LegacyCard, Layout, Page, SkeletonBodyText, SkeletonPage } from '@shopify/polaris';
import DeliveriesDash from '../UI/Dashboard/DeliveriesDash';
import RecentTransfersDash from '../UI/Dashboard/RecentTransfersDash';
import RecentInventoriesDash from '../UI/Dashboard/RecentInventoriesDash';
import { useGlobalStatus } from '../../context/GlobalStatusContext';

const Dashboard = () => {
  const { status, isLoading } = useGlobalStatus();

  if (isLoading && !status) {
    return (
      <SkeletonPage primaryAction>
        <Layout>
          <Layout.Section>
            <LegacyCard sectioned>
              <SkeletonBodyText />
            </LegacyCard>
          </Layout.Section>
        </Layout>
      </SkeletonPage>
    );
  }

  return (
    <Page title="TAREAS PENDIENTES">
      <Layout>
        {/* KPI Row (Styled with Tailwind CSS for extra flair) */}
        <Layout.Section>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 flex flex-col items-center justify-center">
              <span className="text-5xl font-extrabold text-[#545454] mb-2">{status?.deliveries?.count || 0}</span>
              <span className="text-xs font-bold text-gray-500 uppercase tracking-widest text-center">
                Recepciones España Pendientes
              </span>
            </div>
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 flex flex-col items-center justify-center">
              <span className="text-5xl font-extrabold text-[#545454] mb-2">{status?.transfers?.count || 0}</span>
              <span className="text-xs font-bold text-gray-500 uppercase tracking-widest text-center">
                Traspasos Pendientes
              </span>
            </div>
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 flex flex-col items-center justify-center">
              <span className="text-5xl font-extrabold text-[#545454] mb-2">{status?.inventories?.count || 0}</span>
              <span className="text-xs font-bold text-gray-500 uppercase tracking-widest text-center">
                Inventarios Pendientes
              </span>
            </div>
          </div>
        </Layout.Section>

        {/* Column 1 (Large 2/3 width) */}
        <Layout.Section>
          <div className="mb-6">
            <LegacyCard title="ÚLTIMOS TRASPASOS" actions={[{ content: 'Ver todos', url: '/transfers' }]}>
              {status?.transfers?.lasts ? (
                <RecentTransfersDash data={status.transfers.lasts} />
              ) : (
                <div className="p-4 text-center text-gray-500">No hay traspasos pendientes</div>
              )}
            </LegacyCard>
          </div>

          <div className="mb-6">
            <LegacyCard title="RECEPCIONES ESPAÑA" actions={[{ content: 'Ver todas', url: '/deliveries' }]}>
              {status?.deliveries?.lasts ? (
                <DeliveriesDash data={status.deliveries.lasts} />
              ) : (
                <div className="p-4 text-center text-gray-500">No hay recepciones recientes</div>
              )}
            </LegacyCard>
          </div>
        </Layout.Section>

        {/* Column 2 (Small 1/3 width) */}
        <Layout.Section>
          <div className="mb-6">
            <LegacyCard title="INVENTARIOS" actions={[{ content: 'Ver todos', url: '/inventories' }]}>
              <RecentInventoriesDash data={status?.inventories?.lasts} />
            </LegacyCard>
          </div>
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default Dashboard;
